import styled from '@emotion/styled/macro';
import { NavLink } from 'react-router-dom';
import rem from '../../../utils/rem/rem';
import { FocusTriangle } from '../Navigation.styles';
import { StyledProps } from './NavigationLink.types';

export const NavLinkContainer = styled(NavLink)<StyledProps>`
  letter-spacing: ${({ letterSpacing }) => (letterSpacing ? letterSpacing : 'normal')};
  position: relative;
  top: -${({ offset }) => offset}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${rem(24)} 0;
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: ${rem(14)};
  width: 100%;
  overflow: hidden;

  &.active {
    background-color: ${({ theme }) => theme.colors.gray800};
  }

  svg {
    margin-bottom: ${rem(4)};
  }

  &:focus {
    outline: none;
  }

  &:focus ${FocusTriangle} {
    display: block;
  }

  &:hover ${FocusTriangle} {
    display: block;
  }
    
  &:after {
    position: absolute;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.gray900};
    width: ${rem(96)};
    margin: 0 ${rem(24)};
    height: 1px;
    content: '';
  }
  
  ${({ offset }) => offset === 1 && `
    &:before {
      position: absolute;
      top: 0;
      background-color: #131313;
      width: ${rem(96)};
      margin: 0 ${rem(24)};
      height: 1px;
      content: '';
  }
  `}
`;
